// src/AppRoutes.js
import { Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ViewProfilePageAdmin from "./pages/Admin Profile/ViewProfilePageAdmin";
import FaqPage from "./pages/FaqPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AboutUsPage from "./pages/AboutUsPage";
import UsersListPage from "./pages/User/UsersListPage";
import ViewProfilePage from "./pages/User/ViewProfilePage";
import ContentManagementPage from "./pages/ContentManagementPage";
import NotificationPage from "./pages/Notifications/NotificationPage";
import NewsletterPage from "./pages/NewsletterPage";
import HelpCenterListPage from "./pages/HelpCenter/HelpCenterListPage";
import AirdropDashboardPage from "./pages/AirdropCampagin/AirdropDashboardPage";
import BulkUploadPage from "./pages/AirdropCampagin/BulkUploadPage";
import AirdropTransactionsPage from "./pages/AirdropCampagin/AirdropTransactionsPage";
import AirdropTxViewPage from "./pages/AirdropCampagin/AirdropTxViewPage";
import NftCollectionsPage from "./pages/NFT/NftCollectionsPage";
import NftListPage from "./pages/NFT/NftListPage";
import NftMarketplacePage from "./pages/NFT/NftMarketplacePage";
import NftViewPage from "./pages/NFT/NftViewPage";
import NftCollectionViewPage from "./pages/NFT/NftCollectionViewPage";
import NftMarketplaceViewPage from "./pages/NFT/NftMarketplaceViewPage";
import CategoryPage from "./pages/Category/CategoryPage";
import IcoManagePage from "./pages/Ico/IcoManagePage";
import IcoTxViewPage from "./pages/Ico/IcoTxViewPage";
import ProposalPage from "./pages/Proposal/ProposalPage";
import ProposalViewPage from "./pages/Proposal/ProposalViewPage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<HomePageOne />} />
      <Route path="/view-admin-profile" element={<ViewProfilePageAdmin />} />
      <Route path="/view-user-profile/:id" element={<ViewProfilePage />} />
      <Route path="/edit-user-profile/:id" element={<ViewProfilePage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/terms-condition" element={<TermsConditionPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/about-us" element={<AboutUsPage />} />
      <Route path="/users-list" element={<UsersListPage />} />
      <Route path="/newsletter" element={<NewsletterPage />} />
      <Route path="/help-center" element={<HelpCenterListPage />} />
      <Route path="/campaign-manage" element={<AirdropDashboardPage />} />
      <Route path="/campaign-manage/bulk-upload" element={<BulkUploadPage />} />
      <Route
        path="/airdrop-transactions"
        element={<AirdropTransactionsPage />}
      />
      <Route path="/view-airdrop-tx/:id" element={<AirdropTxViewPage />} />
      <Route path="/nft-collections" element={<NftCollectionsPage />} />
      <Route
        path="/view-nft-collection/:id"
        element={<NftCollectionViewPage />}
      />
      <Route path="/nft-list" element={<NftListPage />} />
      <Route path="/nft-view/:id" element={<NftViewPage />} />
      <Route path="/nft-marketplace" element={<NftMarketplacePage />} />
      <Route
        path="/nft-marketplace-view/:id"
        element={<NftMarketplaceViewPage />}
      />
      <Route path="/notifications" element={<NotificationPage />} />
      <Route path="/content" element={<ContentManagementPage />} />
      <Route path="/category" element={<CategoryPage />} />
      <Route path="/ico-manage" element={<IcoManagePage />} />
      <Route path="/ico-tx-view/:id" element={<IcoTxViewPage />} />

      <Route path="/proposal" element={<ProposalPage />} />
      <Route path="/proposal-view/:id" element={<ProposalViewPage />} />

    </Routes>
  );
}

export default AppRoutes;
